import React from 'react';
import { createRoot } from 'react-dom/client';
import { CaptchaDomManager, getCaptchaToken } from './CaptchaDomManager';

window.getCaptchaToken = getCaptchaToken;

const hostId = 'captcha-dom-manager-host';
let host = document.getElementById(hostId);

if (!host) {
    host = document.createElement('div');
    host.id = hostId;
    document.body.appendChild(host);
}

createRoot(host).render(<CaptchaDomManager />);
